import React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

import { Controller } from "react-hook-form";
import { InputLabel, OutlinedInput, Typography } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function SelectCheckMarkComponent(props) {
  const {
    title,
    dataOptions,
    valueData,
    setValueData,
    dataEmpty,
    disabled,
    control,
    name,
    setValue,
    errors,
    clearErrors,
    setValueDataId,
  } = props;
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    let dataNews = typeof value === "string" ? value.split(",") : value;
    setValueData(dataNews);
    setValue(name, dataNews);

    if (setValueDataId) {
      let dataFindId = [];
      dataNews.forEach((itemFind) => {
        let dataFind = dataOptions.find((item) => item.name === itemFind);
        dataFindId.push(dataFind.id);
      });
      setValueDataId(dataFindId);
    }
    clearErrors(name);
    if (dataNews.length === 0) {
      setValue(name, "");
    }
  };
  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel id="demo-simple-select-label" shrink={true}>
        {title}
      </InputLabel>
      <Controller
        control={control}
        name={name}
        defaultValue={""}
        renderValue={(selected) => {
          let dataReturn = [];
          if (selected.length === 0) {
            // return [];
            return (
              <Typography
                sx={(theme) => ({
                  color: theme.palette.secondaryText.main,
                  fontStyle: "italic",
                  boxSizing: "border-box",
                })}
              >
                {title}
              </Typography>
            );
          } else {
            selected.forEach((item, index) => {
              if (index > 0) {
                dataReturn.push(",");
              }
              dataReturn.push(item.name);
            });
          }

          return dataReturn;
        }}
        render={({ field, fieldState }) => (
          <Select
            {...field}
            error={errors[name]}
            notched={true}
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            input={<OutlinedInput label={title} />}
            displayEmpty
            multiple
            InputLabelProps={{ shrink: true }}
            value={valueData}
            onChange={handleChange}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>{dataEmpty}</em>;
              }
              return selected.join(", ");
            }}
            MenuProps={MenuProps}
            size="small"
          >
            {dataOptions.map((name) => (
              <MenuItem key={name.name} value={name.name}>
                <Checkbox checked={valueData.indexOf(name.name) > -1} />
                <ListItemText primary={name.name} />
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </FormControl>
  );
}
